firebird.controller('meetingNotFoundCtrl', [
    '$scope',
    '$window',
    '$stateParams',
    '$timeout',
    '$q',
    'helperService',
    'meetingService',
    'attendeeService',
    'logService',
    'supportLinkService',
    'meetingAPIService',
    'audioFileService',
    'localizationService',
    'brandingService',
    function (
        $scope,
        $window,
        $stateParams,
        $timeout,
        $q,
        helperService,
        meetingService,
        attendeeService,
        logService,
        supportLinkService,
        meetingAPIService,
        audioFileService,
        localizationService,
        brandingService
    ) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'meetingNotFoundCtrl');

        self.meetingCode = '';
        self.headerSnippet = '';
        self.inputPlaceholder = '';
        self.meetingWithShortcutUrlNotActive = false;
        self.meetinghostDisplayName = '';
        self.joinMeeting = joinMeeting;
        self.refresh = refresh;
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.shouldUseIMBrandingStyle = shouldUseIMBrandingStyle;
        self.getStartNowUrl = getStartNowUrl;
        self.showCamaroDetector = false;
        self.onNotifyBtnClicked = onNotifyBtnClicked;
        self.loginToStartMeeting = loginToStartMeeting;
        self.notifyWhenMeetingStarts = false;
        self.checkMeetingStatus = checkMeetingStatus;
        self.checkMeetingStatusTimeout = null;

        self.setupCheckMeetingStatusTimeout = setupCheckMeetingStatusTimeout;
        self.stopCheckMeetingStatusTimeout = stopCheckMeetingStatusTimeout;
        self.showProgress = showProgress;
        self.failedToLaunchApp = false;
        self.showNotifyMeButton = showNotifyMeButton;
        self.addHostLoginBlock = false;
        self.addNotifyMeButton = false;

        $scope.$on('camaro-detection-state-updated', detectionStateUpdated);

        init();

        ////////////////////////

        function init() {
            logger.log('init', 'start init');

            var reason = $stateParams.reason || '';
            var data = $stateParams.data || '';

            //jquery hack for hiding the loading spinner during XHR requests
            $window.$('body > #loading-bar-spinner').hide();

            switch (reason) {
                case 'invalid-meeting-code':
                    self.headerSnippet = localizationService.translate('LOBBY_PAGE.OOPS_WRONG_MEETING_CODE');
                    self.inputPlaceholder = localizationService.translate('LOBBY_PAGE.MEETING_CODE_TEMPLATE');
                    break;
                case 'inactive-shortcut-url':
                    self.meetingWithShortcutUrlNotActive = true;
                    if (
                        !helperService.isUniteApplication() &&
                        !(brandingService.isUB() && !localizationService.isEnLocale())
                    ) {
                        self.addNotifyMeButton = self.addHostLoginBlock = true;
                    }

                    self.logInAndStartMeetingUrl = self.getStartNowUrl();
                    self.homeUrl = helperService.getLocationProtocol() + '://' + helperService.getLocationHost() + '/';
                    self.meetinghostDisplayName = data.name
                        ? data.name
                        : localizationService.translate('LOBBY_PAGE.THE_HOST');
                    self.meetingHostLogo = data.logo ? data.logo : 'img/logos/horizontal.png';

                    self.showCamaroDetector = shouldUseCamaro();

                    if (!self.showCamaroDetector) {
                        if (helperService.isUniteApplication()) {
                            onNotifyBtnClicked();
                        } else {
                            self.setupCheckMeetingStatusTimeout();
                        }
                    }

                    break;
                case 'invalid-shortcut-url':
                    self.headerSnippet = localizationService.translate('LOBBY_PAGE.OOPS_WRONG_MEETING_URL');
                    self.inputPlaceholder = localizationService.translate('LOBBY_PAGE.MEETING_URL_TEMPLATE', {
                        url: helperService.getLocationHost()
                    });
                    self.homeUrl = helperService.getLocationHost() + '/';
                    break;
                case 'no-meeting-code':
                    self.headerSnippet = localizationService.translate('LOBBY_PAGE.OOPS_NO_MEETING_CODE');
                    self.inputPlaceholder = localizationService.translate('LOBBY_PAGE.MEETING_CODE_TEMPLATE');
                    break;
                default:
                    self.headerSnippet = localizationService.translate('LOBBY_PAGE.OOPS_WRONG_MEETING_CODE');
                    self.inputPlaceholder = localizationService.translate('LOBBY_PAGE.MEETING_CODE_TEMPLATE');
                    break;
            }
        }

        function checkMeetingStatus() {
            var deferred = $q.defer();

            logger.log('checkMeetingStatus', 'calling api.getMeetingDetails to check meeting status...');

            //We just need to know if meeting is active or inactive...
            //Any potentially caught errors are irrelevant

            meetingAPIService
                .getMeetingDetails()
                .then(function (meeting) {
                    logger.log('checkMeetingStatus', 'got meeting details', meeting);

                    if (meeting && meeting.meetingStarted) {
                        // Meeting started and currently active
                        // OR
                        // Meeting started but already ended
                        deferred.resolve({ shouldRefresh: true });
                    } else {
                        // Invalid Meeting object
                        // OR
                        // Meeting scheduled but not yet started
                        deferred.resolve({ shouldRefresh: false });
                    }
                })
                .catch(function (err) {
                    logger.error('checkMeetingStatus', 'error when get meeting details', err);
                    //Invalid meeting code
                    deferred.resolve({ shouldRefresh: false });
                });

            return deferred.promise;
        }

        function setupCheckMeetingStatusTimeout() {
            logger.log('setupCheckMeetingStatusTimeout', 'Setup timeout for check meeting status');

            if (self.checkMeetingStatusTimeout) {
                logger.warn('setupCheckMeetingStatusTimeout', 'Check meeting status timeout already initialized');
                return;
            }

            self.checkMeetingStatusTimeout = $timeout(function () {
                logger.log('setupCheckMeetingStatusTimeout', 'inside timeout');

                self.stopCheckMeetingStatusTimeout();

                self.checkMeetingStatus()
                    .then(function (resp) {
                        logger.log(
                            'setupCheckMeetingStatusTimeout',
                            `after checkMeetingStatus (self.notifyWhenMeetingStarts = ${self.notifyWhenMeetingStarts})`,
                            resp
                        );

                        if (resp && resp.shouldRefresh) {
                            //Doing a full page refresh will allow the original init flow/checks to happen
                            //Before sending user to the meeting login page
                            self.refresh();
                        } else {
                            self.setupCheckMeetingStatusTimeout();
                        }
                    })
                    .catch(function (err) {
                        logger.error('setupCheckMeetingStatusTimeout', 'error when check meeting status', err);

                        self.setupCheckMeetingStatusTimeout();
                    });
            }, 10 * 1000);
        }

        function stopCheckMeetingStatusTimeout() {
            logger.log(
                'stopCheckMeetingStatusTimeout',
                'Stopping check meeting status timeout',
                self.checkMeetingStatusTimeout
            );

            if (self.checkMeetingStatusTimeout) {
                $timeout.cancel(self.checkMeetingStatusTimeout);
                self.checkMeetingStatusTimeout = null;
            }
        }

        function joinMeeting(isValid) {
            if (isValid) {
                if (typeof self.meetingCode === 'string') {
                    var lastIndex = self.meetingCode.lastIndexOf('.com/');
                    if (lastIndex !== -1) {
                        self.meetingCode = self.meetingCode.split('.com/').reverse()[0];
                    }
                }

                $window.location.href = self.meetingCode;
            }
        }

        function refresh() {
            logger.log('refresh', 'Refreshing page...');
            $window.location.href = helperService.getUrlWithChimeQueryString();
        }

        function shouldUseIMBrandingStyle() {
            if (helperService.getLocationHost().toLowerCase().indexOf('gomeet') > -1) {
                return true;
            }
            return false;
        }

        function getStartNowUrl() {
            if (attendeeService.getIsHost()) {
                return helperService.getAccountManagerRedirectUrl('Meetings.aspx?action=startNow');
            }

            return helperService.getAccountManagerPassThroughUrl('/AccountManager/Meetings.aspx?action=startNow');
        }

        function onNotifyBtnClicked() {
            logger.log('onNotifyBtnClicked', 'Notify when meeting starts');

            self.notifyWhenMeetingStarts = true;
            self.setupCheckMeetingStatusTimeout();

            // We play this on user interaction to drive up the browser engagement,
            // which will then allow the audio notification chime to be autoplayed when a meeting is started.
            // Notify button cannot be removed from future design since user interaction is required to play audio notification chime.
            audioFileService.playEmptyAudio();
        }

        function loginToStartMeeting() {
            logService.log('meetingNotFound - Login to start meeting - button clicked');

            if (helperService.isNotAuthenticatedUniteApplication()) {
                $window.preloadedApi.remote.ipcRenderer.sendAuthorizationRequest();
            } else {
                const redirectUrl = self.logInAndStartMeetingUrl;
                $window.location.href = redirectUrl;
            }
        }

        function detectionStateUpdated(e, data) {
            self.failedToLaunchApp = data === 'failed';
            if (self.failedToLaunchApp && helperService.isChrome()) {
                self.showCamaroDetector = shouldUseCamaro();
            }
            if (self.failedToLaunchApp) {
                self.setupCheckMeetingStatusTimeout();
            }
        }

        function shouldUseCamaro() {
            var meetingInfo = $stateParams.data || { launchApp: false };
            var launchApp = !helperService.isChrome() || meetingInfo.launchApp;
            return helperService.shouldUseCamaro() && launchApp && !self.failedToLaunchApp;
        }

        function showNotifyMeButton() {
            return !self.showCamaroDetector && !self.notifyWhenMeetingStarts;
        }

        function showProgress() {
            return !(helperService.shouldUseCamaro() && !helperService.isChrome()) && self.notifyWhenMeetingStarts;
        }
    }
]);
